import script from "./AutoAIPromptHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIPromptHistory.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIPromptHistory.vue?vue&type=style&index=0&id=fea06178&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea06178"]])

export default __exports__